export enum EStandardSizes {
  ExtraSmall = "xs",
  Small = "sm",
  Medium = "md",
  Large = "lg",
}
